import { FC, JSX } from 'react';
import {
  Input as JoyInput,
  FormControl,
  FormLabel,
  FormHelperText,
} from '@mui/joy';

import { InputProps as JoyInputProps } from '@mui/joy';

export interface InputProps extends JoyInputProps {
  label?: string;
  errorMessage?: string;
  helperText?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const Input: FC<InputProps> = ({
  label,
  errorMessage,
  helperText,
  size = 'sm',
  required,
  ...rest
}): JSX.Element => {
  return (
    // `required` lives on the FormControl so Joy renders the asterisk on the
    // label; it is forwarded to the input as well for native semantics.
    <FormControl error={!!errorMessage} required={required}>
      {label && <FormLabel>{label}</FormLabel>}
      <JoyInput {...rest} required={required} size={size} />
      <FormHelperText>
        {errorMessage ? errorMessage : helperText}
      </FormHelperText>
    </FormControl>
  );
};
